// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {RefObject, useEffect} from 'react';

export const use_click_outside = <T extends HTMLElement>(
    ref: RefObject<T>,
    cb?: ()=>void)=>
    {
    useEffect(()=>{
        const on_click = (event: MouseEvent)=>{
            if (ref.current && !ref.current.contains(event.target as Node))
                cb?.();
        };
        document.addEventListener('mousedown', on_click);
        return ()=>{ document.removeEventListener('mousedown', on_click); };
    }, [ref, cb]);
};
